/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { useState, useEffect } from 'react';

export function useIsTrackEnabled(track?: VideoProvider.ITrack) {
  const [isEnabled, setIsEnabled] = useState(track?.isEnabled ?? false);

  useEffect(() => {
    setIsEnabled(track?.isEnabled ?? false);

    // TODO: (ZOOMSDK) - add support for track.on(enabled|disabled) in Zoom and remove track?.isEnabled dependency
    if (track?.on) {
      const setEnabled = () => setIsEnabled(true);
      const setDisabled = () => setIsEnabled(false);
      track.on('enabled', setEnabled);
      track.on('disabled', setDisabled);
      return () => {
        track?.off && track.off('enabled', setEnabled);
        track?.off && track.off('disabled', setDisabled);
      };
    }
    return;
  }, [track, track?.isEnabled]);

  return isEnabled;
}
